export default function autoContrastController() {
  initAutoContrast();
  document.addEventListener('shopify:section:load', (e) => applyToTree(e.target));

  function initAutoContrast() {
    applyToTree(document);
  }

  function applyToTree(root) {
    root.querySelectorAll('[data-auto-contrast]').forEach(applyAutoContrast);
  }

  function applyAutoContrast(el) {
    const bg = findBackgroundColor(el);
    if (!bg) return; // nothing found → leave existing text colour
    el.style.color = idealTextColor(bg); // set to #000000 or #ffffff

    if ((el.dataset.autoContrast = 'block-rendering')) {
      el.dataset.autoContrast = 'initialised';
    }
  }

  /* ───────── helpers ───────── */

  function findBackgroundColor(node) {
    if (!node) return null;
    const cs = getComputedStyle(node);

    /* 1 – gradient? grab first colour-stop */
    const img = cs.backgroundImage;
    if (img && img !== 'none') {
      const m = img.match(/rgba?\([^)]+\)|#[\da-f]{3,8}/i);
      if (m) return normaliseColor(m[0]);
    }

    /* 2 – solid colour? */
    const bg = cs.backgroundColor;
    if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return normaliseColor(bg);

    /* 3 – try parent */
    return findBackgroundColor(node.parentElement);
  }

  function normaliseColor(cssColor) {
    /* Tiny canvas turns ANY valid CSS colour into “rgb(r, g, b)” */
    const c = document.createElement('canvas').getContext('2d');
    c.fillStyle = cssColor.trim();
    return c.fillStyle; // always rgb(...)
  }

  function toRGB(cssColor) {
    // hex?  #rgb  #rgba  #rrggbb  #rrggbbaa
    if (cssColor.startsWith('#')) {
      let hex = cssColor.slice(1);
      if (hex.length === 3 || hex.length === 4) {
        hex = [...hex].map((h) => h + h).join(''); // #abc → #aabbcc
      }
      const int = parseInt(hex.slice(0, 6), 16);
      return [(int >> 16) & 255, (int >> 8) & 255, int & 255];
    }

    // rgb/rgba()
    const m = cssColor.match(/\d+/g);
    return m ? m.slice(0, 3).map(Number) : null;
  }

  function idealTextColor(cssColor) {
    const rgb = toRGB(cssColor);
    if (!rgb) return '#000000'; // fallback – should never happen

    const [r, g, b] = rgb.map((c) => {
      c /= 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });

    const L = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    const contrastWhite = (1 + 0.05) / (L + 0.05);
    const contrastBlack = (L + 0.05) / 0.05;

    return contrastWhite > contrastBlack ? '#ffffff' : '#000000';
  }
}
